module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "capterra.7a47a480.svg";